import Container = Phaser.GameObjects.Container;
import { Scene } from 'phaser';
import { SpineAnim } from './spineAnim';

export class VineView extends Container {
    private spine: SpineAnim;

    constructor(scene: Scene) {
        super(scene);

        this.spine = new SpineAnim(this.scene, 'Vine');
        this.add(this.spine);
        this.spine.setScale(0.9);
        this.spine.y += 278;

        const { spine } = this.spine;
        this.spine.startAnimation(spine.getAnimationList());

        spine.timeScale = 0;

        const staticSprite = this.scene.add.sprite(-12, -1890, 'game', 'vine.png');
        staticSprite.setScale(1.4);
        this.add(staticSprite);

        // const point = this.scene.add.graphics();
        // point.fillStyle(0x0000ff, 1);
        // point.fillCircle(0, 0, 25);
        // this.add(point);
    }

    public playAnimation() {
        this.spine.spine.timeScale = 0.68;
        this.scene.time.delayedCall(45, () => {
            this.spine.spine.timeScale = 0.58;
        });
        this.spine.spine.once('complete', () => {
            this.destroy();
        });
    }
}
